import { faFilePdf, faFolder } from "@fortawesome/free-regular-svg-icons";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { InfoBarContext } from "../../../common/info";
import { isTouch } from "../../../utils/screenUtil";
import SubmittedDocumentation from "./preview/SubmittedDocumentation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PreviewResolvedRequest from "./PreviewResolvedRequest";
import { getAccessToken } from "../../../common/authorization/AuthorizeService";
import Tooltip from "../../../common/tooltip/Tooltip";

function ConfirmationAwaited({ title, requests, activeJournalId, setActiveJournalId }) {
  const infoBar = useContext(InfoBarContext);
  const { t } = useTranslation();

  return (
    <>
      <div className="subtitle">{title}</div>
      {requests &&
        requests.map((request, index) => (
          <PreviewResolvedRequest
            className={isTouch() && index > 0 ? "mt-6" : ""}
            key={`confirmationAwaited${index}`}
            {...request}
            blur={activeJournalId && activeJournalId !== request.uid}
            setActiveJournalId={setActiveJournalId}
            receiptDate={request.submissionDate}
            decisionReceiptDate={request.decisionReceiptDate}
            decisionStatusText={request.decisionTitle}
            renderRequestActions={() => (
              <button className={"button is-light has-background-white"}>
                <Tooltip
                  content={"Predana dokumentacija"}
                  children={
                    <FontAwesomeIcon
                      className="is-clickable"
                      icon={faFolder}
                      onClick={() => {
                        setActiveJournalId(request.uid);
                        infoBar.toggle(t("requests.submittedDocumentation.title"), () => (
                          <SubmittedDocumentation
                            letters={request.letters}
                            attachments={request.attachments}
                            finances={request.finances}
                          />
                        ));
                      }}
                      size="2x"
                    />
                  }
                ></Tooltip>
              </button>
            )}
            renderDecisionActions={() =>
              request.decisionUrl && (
                <button
                  target="_blank"
                  className={"button is-light has-background-white"}
                  rel="noopener noreferrer"
                  onClick={async () =>
                    fetch(`${process.env.REACT_APP_GATEWAY_URL}${request.decisionUrl}`, {
                      method: "GET",
                      headers: {
                        "Request-Origin": "pisarnica",
                        Authorization: "Bearer " + (await getAccessToken()),
                      },
                      mode: "cors",
                      credentials: "include",
                    })
                      .then((response) => response.blob())
                      .then((file) => window.open(URL.createObjectURL(file)))
                  }
                >
                  <Tooltip
                    content={"Rezultat predanog zahtjeva"}
                    children={
                      <FontAwesomeIcon
                        className="is-clickable has-text-danger"
                        icon={faFilePdf}
                        size="2x"
                      />
                    }
                  ></Tooltip>
                </button>
              )
            }
          />
        ))}
    </>
  );
}

export default ConfirmationAwaited;
